module.exports = __webpack_public_path__ + "img/唐泳.55280083.png";